// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"menu-item_1AO3bt","menuItem":"menu-item_1AO3bt","icon":"icon_xu_-Fa","txt":"txt_1wSopn","active":"active_3cCOst"};